import styled from "styled-components";

export const EditableCustomerAttributeContent = styled.div`
  word-break: break-all;
  white-space: pre-line;
`;
